/* Dansk katalog for locale-advisor-costs-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'adv.cost.review': 'Se nærmere',
  'adv.cost.moreTitle': 'Flere muligheder',
  'adv.cost.observedValue': 'Observeret værdi',
  'adv.cost.invoiceBasis': 'Faktureringsgrundlag',
  'adv.cost.draftValue': 'Kladdeværdi',
  'adv.cost.possibleCount': 'Mulige dubletter',
  'adv.cost.purchaseShare': 'Indkøbsandel',
  'adv.cost.givenDiscount': 'Givet rabat',
  'adv.cost.unbilledNote': 'Faktureringsgrundlag, ikke bogført indtægt',
  'adv.cost.draftNote': 'Kladdeværdi, ikke bogført indtægt',
  'adv.cost.acceptedNote': 'Accepterede tilbud uden tilknyttet faktura',
  'adv.cost.duplicateNote': 'Mulige dubletter, der skal kontrolleres',
  'adv.cost.supplierNote': 'Indkøbsvolumen, der kan give grundlag for forhandling',
  'adv.cost.discountTitle': 'Gennemgå de rabatter, der er givet',
  'adv.cost.discountNote': 'Faktisk givet rabat, ikke beregnet besparelse',
  'adv.cost.voucherNote': 'Dokumentation, der skal følges op; ingen beregnet besparelse',
  'adv.cost.followUp': 'Til opfølgning',
  'adv.cost.increaseToReview': 'Stigning, der bør undersøges',
  'adv.cost.fixedTitle': 'Bogførte faste omkostninger',
  'adv.cost.tryAdjustment': 'Prøv en justering',
  'adv.cost.fixedDetail': 'Gennemsnit pr. måned, baseret på {months} hele måneder',
  'adv.cost.otherTitle': 'Største øvrige omkostningskonti',
  'adv.cost.otherIntro': 'Andelen viser bogført omkostning i forhold til omsætningen i det valgte år. Den er ikke et besparelsesestimat, og kontoen klassificeres ikke automatisk som variabel.',
  'adv.cost.otherDetail': '{amount} bogført i det valgte år',
  'adv.cost.ofRevenue': 'af omsætningen',
  'adv.cost.noRevenueShare': 'Andel ikke beregnet',
  'adv.cost.sub': 'Største bogførte omkostningskonti og ændring i forhold til sidste år',
  'adv.cost.subPeriod': 'Største bogførte omkostningskonti og ændring i forhold til samme periode sidste år',
  'adv.cost.help': 'Kontiene kommer fra resultatrapporten for det valgte år. Søjlerne viser bogført beløb pr. konto. Ændring vises kun, når samme konto har et positivt beløb sidste år.',
  'adv.cost.helpPeriod': 'Kontiene kommer fra resultatrapporten til og med indeværende måned. Søjlerne viser bogført beløb pr. konto. Ændringen sammenlignes med samme periode sidste år, når kontoen havde et positivt beløb.',
  'adv.cost.rowHelp': 'Bogført på kontoen: {amount} i det valgte år. Ændring i forhold til sidste år: {change}.',
  'adv.cost.noComparison': 'Ingen tal fra sidste år',
  'adv.cost.emptyText': 'Ingen bogførte omkostningskonti i det valgte år.',
  'adv.cost.flagText': '{name} er steget betydeligt i forhold til sidste år. Kontrollér, om ændringen er planlagt, og gennemgå posteringerne på kontoen.',
  'adv.why.costSub': 'Omkostningskonti, der er steget betydeligt i forhold til sidste år',
});
